<section>
    <div class="scroll-container">
        <div nz-row>
            <div nz-col nzSpan="18">
                <div class="heading-fs-18 mb-0">
                    <span nz-icon nzType="arrow-left" nzTheme="outline" class="drawer-back-arrow mr-2 disp-mob"
                        (click)="cancel()"></span>
                    All Layouts
                </div>
            </div>
            <div nz-col nzSpan="6" class="text-right pt-2 disp-web">
                <span nz-icon nzType="close" nzTheme="outline" class="cursor-pointer" (click)="cancel()"></span>
            </div>
            <div nz-col nzSpan="24">
                <nz-divider></nz-divider>
            </div>
        </div>

        <div nz-row>
            <div nz-col nzSpan="24">
                <form nz-form>
                    <div class="d-flex">
                        <div class="w-100 mr-3">
                            <div class="input-container mt-2">
                                <nz-form-item class="mb-0">
                                    <nz-form-control class="drawer-search-input">
                                        <nz-input-group [nzPrefix]="prefixIcon" [nzSuffix]="suffixIcon">
                                            <input nz-input placeholder="Search Layout" name="filterKey"
                                                [(ngModel)]="filterKey" (keydown.enter)="onSearch()"
                                                (ngModelChange)="filterKeyChanged()" [maxlength]="100"
                                                [disabled]="!hasLayouts" appAlphaNumericsLevelThree />
                                        </nz-input-group>
                                        <ng-template #suffixIcon>
                                            <span nz-icon nzType="close" nzTheme="outline" *ngIf="filterKey"
                                                (click)="clearSearch()" class="clear-search cursor-pointer"></span>
                                        </ng-template>
                                        <ng-template #prefixIcon>
                                            <span nz-icon nzType="search" nzTheme="outline" (click)="onSearch()"
                                                class="cursor-pointer"></span>
                                        </ng-template>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <nz-spin [nzSpinning]="isLoading">
            <div *ngIf="isModelLoaded && model && model.length > 0">
                <div nz-row *ngFor="let item of model" [nzGutter]="[16,16]"
                    (click)="selectLayout(item)" class="list-item mb-2 pt-1 cursor-pointer"
                    [class.selected-item]="item['isSelected']">
                    <div nz-col nzSpan="16">
                        <div nz-row class="align-items-center">
                            <div class="d-flex align-items-center overflow-hidden">
                                <div class="cursor-pointer mr-3 list-img-wrapper d-flex align-items-center justify-content-center"
                                    (click)="selectLayout(item)">
                                    <span nz-icon nzType="layout" nzTheme="outline" class="filter_darkmode"
                                        style="font-size: 22px;"></span>
                                </div>
                                <span class="cursor-pointer text-ellipsis"
                                    (click)="selectLayout(item)">{{item.value}}</span>
                            </div>
                        </div>
                    </div>
                    <div nz-col nzSpan="8" class="align-items-center d-flex justify-content-end">
                        <span *ngIf="item['isSelected']" nz-icon nzType="check-circle" nzTheme="fill"
                            style="color: #1677ff; font-size: 16px;"></span>
                    </div>
                    <nz-divider class="mt-1 mb-0"></nz-divider>
                </div>
            </div>
            <div *ngIf="isModelLoaded && model && model.length === 0 && hasLayouts" class="empty-list-container">
                <span class="text-muted fs-14">No layouts match your search</span>
            </div>
            <div *ngIf="isModelLoaded && !hasLayouts" class="empty-list-container">
                <span class="text-muted fs-14">No layouts found</span>
            </div>
        </nz-spin>
    </div>
</section>
